import _ from "lodash";

/**
 * Calcula totales de Tarifa y Honorarios para una liquidación
 * @param {Array} gastos - registros de gastoenfermeria
 * @param {Array} asistencias - registros de asistencia
 * @param {Array} legajos - registros de legajoenfermeria
 * @returns {{ tarifa: number, honorarios: number }}
 */
export const calcularTotales = (gastos, asistencias, legajos) => {
  let totalTarifa = 0;
  let totalHonorarios = 0;

  // Gastos
  gastos.forEach((g) => {
    const monto = parseInt(g.monto) || 0;
    if (g.paraTarifa?.toUpperCase() === "SI") totalTarifa += monto;
    if (g.paraHonorario?.toUpperCase() === "SI") totalHonorarios += monto;
  });

  // Asistencias
  asistencias.forEach((a) => {
    if (a.paratarifa?.toUpperCase() === "SI")
      totalTarifa += parseInt(a.tarifa) || 0;
    if (a.parahonorario?.toUpperCase() === "SI")
      totalHonorarios += parseInt(a.honorario) || 0;
  });

  // Legajos (con fórmulas específicas)
  const marcHonorario = _.sumBy(
    legajos.filter((m) => m.paraHonorario === "SI"),
    (m) =>
      Number(
        m.CostoHoraProfesional *
          (Number(Number(m.horashoraextra).toFixed(2)) +
            (m.horascalculadas || 0)) +
          (m.CostoHoraProfesional *
            (m.horasferiado || 0) *
            (m.porcentajeferiado || 0)) /
            100
      )
  );

  const marcTarifa = _.sumBy(
    legajos.filter((m) => m.paraTarifa === "SI"),
    (m) =>
      Number(
        m.CostoHoraEmpresa *
          (Number(Number(m.horashoraextra).toFixed(2)) +
            (m.horascalculadas || 0)) +
          (m.CostoHoraEmpresa *
            (m.horasferiado || 0) *
            (m.porcentajeferiado || 0)) /
            100
      )
  );

  totalHonorarios += marcHonorario;
  totalTarifa += marcTarifa;

  return {
    tarifa: Math.round(totalTarifa),
    honorarios: Math.round(totalHonorarios),
  };
};
